import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MovimientoDetailDto } from '@models/movimiento/movimientoDetailDto.model';
import { MovimientosService } from '@services/movimientos/movimientos.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-dialog-view-movimiento',
  templateUrl: './dialog-view-movimiento.component.html',
  styleUrls: ['./dialog-view-movimiento.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogViewMovimientoComponent {

  movimientoDetailDto!: MovimientoDetailDto

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DialogViewMovimientoComponent>,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private movimientosService: MovimientosService,
  ) {
    this.getMovimientoById()

  }

  getMovimientoById() {
    this.spinner.show("spMovimiento")
    this.movimientosService.getById(this.data.id)
      .subscribe(
        data => {
          this.spinner.hide("spMovimiento")
          this.movimientoDetailDto = data
        },
        error => {
          this.spinner.hide("spMovimiento")
          this.snackBar.showError(error, "Error");
        })
  }
}
